import { render } from "./SnapchatIcon.vue?vue&type=template&id=5a1a6404"
import script from "./SnapchatIcon.vue?vue&type=script&lang=js"
export * from "./SnapchatIcon.vue?vue&type=script&lang=js"

import "./SnapchatIcon.vue?vue&type=style&index=0&id=5a1a6404&lang=css"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__